@if (method == "SMS") {
  <app-otp-verify-sms [fromPage]="fromPage" />
} @else if (method == "EMAIL") {
  <app-otp-verify-email [fromPage]="fromPage" />
}
